/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'arrow_right': {
    width: 10,
    height: 18,
    viewBox: '0 0 10 18',
    data: '<path pid="0" d="M.248 1.441A.843.843 0 111.44.247l8.156 8.155-.335.335.336-.333a.847.847 0 010 1.193L1.44 17.753a.842.842 0 01-1.194 0 .845.845 0 010-1.194l7.56-7.56-7.56-7.558z" _fill="#A7AEB6" fill-rule="nonzero"/>'
  }
})
